export default __webpack_public_path__ + "static/media/tailoring.3fbe7548.svg";